'use strict';

(function () {
	function withZero (time) {
		let nTime = time;
		if (time < 10) {
			nTime = '0' + time;
		}
		return nTime;
	}

	function correctTime (date) {
		let open = true;
		let h = date.getHours();
		let m = date.getMinutes();

		if (h < 9 || h > 18) {
			open = false;
		}

		return {text: `${withZero(h)}<span class="dot-anim">:</span>${withZero(m)}`, opened: open};
	}

	function getTimeUTC () {
		let d = new Date();
		let utc = d.getTime() + (d.getTimezoneOffset() * 60000);
		return utc;
	}

	function setTime (offset) {
		let date = new Date(getTimeUTC() + (3600000 * offset));
		return correctTime(date);
	}

	function renderTime () {
		$('.js-time').each(function (i) {
			let $this = $(this);
			let tz = $this.data('timezone');
			let time = setTime(tz);

			setTimeout(function () {
				$this.html(time.text);
				if (!time.opened) {
					$('.time-office', $this.closest('.grid')).addClass('_color-border');
				}
			}, 100 * i);
		});
	}
	renderTime();
	setInterval(renderTime, 5000);
}());



// WEBPACK FOOTER //
// ./src/js/_modules/time.js